import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { useLocation } from 'react-router'
import Hamburger from './Hamburger'
import Close from './Close'
import Socials from './Socials'
import { navigation } from '../constants/navigation'

const Logo = require('../../img/drippy_rugs_logo_320x320.png')

export default function MobileNavigation() {
    const location = useLocation()
    const [opened, setOpened] = useState(false)

    useEffect(() => {
        if (opened)
            document.querySelector('body')?.classList.add('overflow-hidden')
        else document.querySelector('body')?.classList.remove('overflow-hidden')
    }, [opened])

    useEffect(() => {
        handleClose()
    }, [location.pathname])

    const handleOpen = () => setOpened(true)
    const handleClose = () => setOpened(false)

    return (
        <>
            <button
                type="button"
                onClick={handleOpen}
                className={`sm:hidden absolute right-6 top-6 ${
                    opened ? 'opacity-0' : 'opacity-100'
                } duration-300 font-bold select-none`}
            >
                <Hamburger />
            </button>

            <nav
                id="mobileNavigation"
                className={`sm:hidden fixed z-10 left-0 ${
                    opened ? 'top-0' : 'top-[-100vh]'
                } w-screen h-screen backdrop-blur-md overflow-hidden ease-in-out duration-300 select-none`}
            >
                <div className="relative w-full h-full flex flex-col items-center bg-black bg-opacity-60 bg pt-4">
                    <button
                        type="button"
                        onClick={handleClose}
                        className="sm:hidden absolute right-6 top-6"
                    >
                        <Close animate={opened} />
                    </button>

                    <Link to="/">
                        <h1 className="relative block w-[160px] [h-160px] hover:glow hover:animate-shake duration-200">
                            <img
                                src={Logo}
                                alt={'@drippy_rugs logo'}
                                width={160}
                                height={160}
                            />
                        </h1>
                    </Link>

                    <ul className="my-auto h-1/2 flex flex-col justify-evenly items-center text-2xl font-heading">
                        {navigation
                            .filter((item) => item.showNav)
                            .map((item) => (
                                <li key={item.href}>
                                    <Link
                                        to={item.href}
                                        className={`inline-block hover:text-red-600 duration-200
                                        ${
                                            item.href === location.pathname
                                                ? 'text-red-600'
                                                : 'text-white'
                                        }
                                    `}
                                    >
                                        {item.title}
                                    </Link>
                                </li>
                            ))}
                        <li>
                            <Socials />
                        </li>
                    </ul>
                </div>
            </nav>
        </>
    )
}
